import type { SceneNumberingMode } from "@supermanus/document-model";

export interface SceneMoveDialogProps {
  mode: SceneNumberingMode;
  onRenumber: () => void;
  onKeepNumbers: () => void;
  onCancel: () => void;
}

/**
 * Shown after a scene drag-reorder. Copy depends on the episode's numbering mode.
 */
export function SceneMoveDialog({
  mode,
  onRenumber,
  onKeepNumbers,
  onCancel,
}: SceneMoveDialogProps) {
  return (
    <div
      className="sm-dialog-backdrop"
      role="presentation"
      onClick={onCancel}
    >
      <div
        className="sm-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="sm-scene-move-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="sm-scene-move-title">Flyt scene</h2>
        {mode === "sequential" ? (
          <>
            <p>
              Du har flyttet en scene. Vil du opdatere scenenumrene, så de
              stadig er kronologisk fortløbende (1, 2, 3 …), eller beholde de
              hidtidige numre?
            </p>
            <div className="sm-dialog-actions">
              <button type="button" onClick={onCancel}>
                Annuller
              </button>
              <button type="button" onClick={onKeepNumbers}>
                Behold numre
              </button>
              <button
                type="button"
                className="sm-dialog-primary"
                onClick={onRenumber}
              >
                Omnummerér fortløbende
              </button>
            </div>
          </>
        ) : (
          <>
            <p>
              Scenen flyttes. Med brugerdefinerede scenenumre ændres numrene
              ikke automatisk — ret dem manuelt på Sceneliste eller ved
              sceneoverskriften i manus/noter. Nummereringsmodus skifter du i
              Indstillinger.
            </p>
            <div className="sm-dialog-actions">
              <button type="button" onClick={onCancel}>
                Annuller
              </button>
              <button
                type="button"
                className="sm-dialog-primary"
                onClick={onKeepNumbers}
              >
                Flyt scene
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
